const invoicesConstantsEN = {
  invoicesPageTitle: 'Slips',
  invoicesBreadcrumb: 'ALL SLIPS',
  invoiceDetailsBreadcrumb: 'SLIP DETAILS',
  totalInvoicesItems: 'Slips',
  statusPlaceholder: 'Status',
  allFilter: 'All',
  pendingInvoiceStatus: 'Pending',
  paidInvoiceStatus: 'Paid',
  failedInvoiceStatus: 'Failed Payment',
  cancelledInvoiceStatus: 'Cancelled',
  invoicesTableIssueDateColumn: 'ISSUE DATE',
  invoicesTableInvoiceIdColumn: 'SLIP ID',
  invoicesTableOrderIdColumn: 'ORDER ID',
  invoicesTableCustomerColumn: 'CUSTOMER',
  invoicesTableTotalPriceColumn: 'TOTAL PRICE',
  invoicesTableStatusColumn: 'STATUS',
  invoicesMediaTitles: 'Media Titles',
  invoicesPaymentMethod: 'Payment Method',
  invoicesTax: 'Tax',
  invoicesTableActionsColumn: 'ACTIONS',
  invoiceTableEditButton: 'Edit',
  processingInvoiceStatus: 'Processing',
};

export default invoicesConstantsEN;
